/*
 * translations.js — TheMarketKilla
 * Contenido real de la marca. Precios: themarketkilla-brand/reference/catalogo.md
 * Regla: nada de cifras inventadas, promesas de rentabilidad ni resultados no verificables.
 */

export const translations = {
  es: {
    nav: {
      services: "Servicios",
      markets: "Mercados",
      pricing: "Accesos",
      contact: "Contacto",
      cta: "Escríbeme",
    },
    hero: {
      kicker: "TRADING AUTOMATIZADO · FOREX · ORO · CRYPTO",
      title_a: "El sistema opera.",
      title_b: "Con reglas, no con emoción.",
      subtitle:
        "+10 años operando Forex, Oro y Crypto. +500 estrategias programadas. Robots que ejecutan la misma disciplina de siempre, 24/5, sin dudar y sin avaricia.",
      cta_primary: "Ver cómo funciona",
      cta_secondary: "Ver mercados en vivo",
      stat_a: "Años en los mercados",
      stat_b: "Estrategias programadas",
      stat_c: "FTMO Challenge pasado",
    },
    ticker: { live: "EN VIVO" },
    markets: {
      kicker: "DATOS · BINANCE · TIEMPO REAL",
      title: "Sala de mercados",
      subtitle:
        "Precios spot directos del libro de órdenes de Binance. BTC, ETH, XRP y oro tokenizado (PAXG) — actualizados cada 15 segundos.",
      change_24h: "24h",
      high: "Máx 24h",
      low: "Mín 24h",
      vol: "Volumen",
    },
    services: {
      kicker: "SERVICIOS · THEMARKETKILLA",
      title: "Cuatro formas de operar conmigo. 👇",
      subtitle:
        "Del robot que trabaja solo al grupo donde guiamos el ciclo alcista. Elige por dónde entrar.",
      card_cta: "Ver el servicio completo",
      list: {
        copytrading: {
          tag: "01",
          title: "CopyTrading en Oro",
          badge: "GRATIS",
          desc: "Copio mis operaciones de scalping en Oro (XAUUSD) desde una cuenta Master. Tú solo conectas y ajustas el lote. Es gratis si abres tu cuenta de Roboforex con mi código.",
          meta: "Roboforex · MT5 ProCent · mínimo $100",
        },
        breakouts: {
          tag: "02",
          title: "Robot BreakOuts",
          badge: "GRATIS O $490",
          desc: "Mi robot de MT5: busca la tendencia y entra en cada ruptura a favor. Multipar, con stop bajo la estructura, BreakEven y TrailingStop. Nunca Grid, nunca Martingala. Lo pasó al 100 % en FTMO.",
          meta: "MT5 · Forex · Oro · Índices · Fondeo",
        },
        bullrun: {
          tag: "03",
          title: "Bull Run 2026",
          badge: "10 PLAZAS",
          desc: "Grupo privado para recorrer el ciclo alcista: qué acumular y por qué, con visión macro y rebalanceo táctico. Solo 10 personas, para poder escribirles una por una.",
          meta: "Pago único $490 · grupo privado",
        },
        senales: {
          tag: "04",
          title: "Señales",
          badge: "PRÓXIMAMENTE",
          desc: "Forex, Crypto, Índices y Metales. De 2 a 10 señales por semana, cada una con Stop Loss estricto, Take Profit, BreakEven y TrailingStop. Entrega por canal privado.",
          meta: "Desde $30/mes",
        },
      },
      page_nav_back: "Todos los servicios",
      nav_label: "Servicios",
      pages: {
        copytrading: {
          seo: {
            title: "CopyTrading en Oro (XAUUSD) — Gratis con Roboforex | TheMarketKilla",
            description: "Mis operaciones de scalping en Oro copiadas automáticamente a tu cuenta. Gratis con tu cuenta de Roboforex. Mínimo $100. Resultados auditados en Myfxbook.",
          },
          kicker: "COPYTRADING · XAUUSD · ROBOROREX",
          title_a: "Una estrategia ganadora en Oro,",
          title_b: "copiadas a tu cuenta.",
          lead: "Opero yo. Copias tú. Mi cuenta Master de scalping en Oro (XAUUSD) replica cada entrada en tu cuenta de Roboforex de forma automática: mismo Stop Loss, mismo Take Profit, misma salida. Tú no necesitas estar frente al gráfico, ni VPS, ni PC encendido. Abres la cuenta con mi código y el servicio es gratis.",
          nav_label: "CopyTrading en Oro",
          cta_label: "Escribirme por Telegram",
          cta_href: "https://t.me/TheMarketKilla",
          cta2_label: "Abrir mi cuenta en Roboforex",
          cta2_href: "https://my.roboforex.com/en/?a=emvr",
          facts: [
            { label: "Activo", value: "XAUUSD" },
            { label: "Cuenta", value: "MT5 ProCent" },
            { label: "Mínimo", value: "$100" },
            { label: "Costo", value: "GRATIS" },
          ],
          aside: {
            title: "La ficha",
            price: "GRATIS",
            price_note: "con mi código de Roboforex",
            items: [
              "Copiado automático de mis operaciones",
              "Scalping en Oro (XAUUSD), 5–30 min por trade",
              "Mi cuenta Master, en abierto",
              "Stop Loss en cada entrada. Nunca Grid ni Martingala",
              "Sin cuotas, sin mensualidades, sin permanencia",
              "Cupos limitados (trabajo con una sola Master)",
            ],
            note: "El servicio es gratis porque abres tu cuenta con mi enlace de referido. Tú te quedas el 100 % de tus resultados: tu dinero nunca sale de tu cuenta.",
          },
          how: {
            kicker: "CÓMO FUNCIONA",
            title: "Copia proporcional, sin intermediarios.",
            items: [
              { n: "01", t: "Mi cuenta Master", d: "Yo opero desde una única cuenta Master: scalping en Oro, con la estrategia The Million's Strategy. Cada entrada lleva su Stop Loss definido antes de abrir, con un riesgo por operación del 0,7 % que mantiene la curva estable mes a mes." },
              { n: "02", t: "Tu cuenta se suscribe", d: "Desde el panel de Roboforex conectas tu cuenta a la estrategia. El copiado es proporcional a tu balance, con el lote que tú decidas." },
              { n: "03", t: "0 lag, todo automático", d: "Al ser el mismo broker (Roboforex), la copia llega sin retardo entre servidores. Tu cuenta trabaja sola, 24/5, sin que hagas nada." },
            ],
          },
          steps: {
            kicker: "CÓMO SE EMPIEZA",
            title: "De cero a copiando, en 5 pasos.",
            items: [
              { n: "1", t: "Abre tu cuenta", d: "Regístrate en Roboforex con mi enlace (código emvr). Es gratis y toma un par de minutos." },
              { n: "2", t: "Elige MT5 ProCent", d: "Al crear la cuenta escoge el tipo MT5 ProCent y deposita desde $100." },
              { n: "3", t: "Verifica y deposita", d: "Completa la verificación del broker y fondea tu cuenta. Mínimo $100 para operar en proporción." },
              { n: "4", t: "Avísame", d: "Me escribes por Telegram con tu número de cuenta. Yo te envío el enlace de CopyTrading." },
              { n: "5", t: "Conecta y listo", d: "Aceptas la solicitud de copia y eliges tu lote. Desde ahí, cada operación mía se replica en tu cuenta." },
            ],
            footnote: "Si un paso se traba, me escribes y lo resolvemos juntos. Es tu cuenta, tu broker y tu dinero: tú mantienes el control en todo momento.",
          },
          proof: {
            kicker: "PRUEBAS · MYFXBOOK CERTIFICADO",
            title: "Los resultados no se dicen: se verifican.",
            text: "Mi cuenta Master está monitoreada y certificada por Myfxbook, la plataforma de verificación de operaciones más usada del sector. Puedes abrir el historial completo, operación por operación, cuando quieras. Los enlaces son públicos y permanentes.",
            shots: [
              { src: "/media/copytrading/myfxbook-master-1.jpg", alt: "Widget de Myfxbook de la Master 1 de TheMarketKilla", label: "MASTER 1 · MYFXBOOK", caption: "Cuenta verificada. El porcentaje cambia a diario porque la cuenta está operando: por eso vale más el enlace que el número." },
              { src: "/media/copytrading/myfxbook-master-2.jpg", alt: "Widget de Myfxbook de la Master 2 de TheMarketKilla", label: "MASTER 2 · MYFXBOOK", caption: "Segunda Master, también certificada por Myfxbook. Misma estrategia, misma disciplina de riesgo." },
            ],
            video: {
              src: "/media/copytrading/copytrading-lib.mp4",
              label: "COPYTRADING EN VIVO",
              caption: "Grabación de la cuenta operando en tiempo real: entradas, gestión y cierres.",
            },
            links: [
              { label: "MASTER 1", text: "Historial completo, verificado por Myfxbook.", href: "https://www.myfxbook.com/members/TheMarketKilla/themarketkilla-millions-strategy-1/12241336" },
              { label: "MASTER 2", text: "Segunda Master, también verificada.", href: "https://www.myfxbook.com/members/TheMarketKilla/themarketkilla-millions-strategy-2/12241349" },
              { label: "CUENTA MASTER EN ROBOROREX", text: "Estrategia de entrada desde $100 (MT5 ProCent).", href: "https://my.roboforex.com/en/copy-trading/my/strategies/bbba/37393149/overview" },
              { label: "ROBOROREX · CUENTA MT5", text: "Tipo de cuenta que se usa para el copiado.", href: "https://my.roboforex.com/en/?a=emvr" },
            ],
            disclaimer: "Las cifras y la curva se actualizan a diario: cada enlace muestra el dato de hoy, no el de un folleto. Operamos con Stop Loss en cada entrada, sin Grid ni Martingala, con un riesgo máximo del 0,7 % por operación: un modelo de gestión diseñado para proteger el capital en cada ciclo.",
          },
          honest: {
            kicker: "SIN VENDERTE HUMO",
            title: "Lo que este servicio NO es.",
            items: [
              "No es humo: cada resultado que ves está verificado por Myfxbook y puedes auditarlo tú mismo, operación por operación.",
              "No hay Grid ni Martingala. Cada operación lleva Stop Loss y riesgo definido antes de entrar: así se protege el capital.",
              "Tu dinero nunca pasa por mis manos: se queda siempre en tu cuenta de Roboforex, bajo tu control total.",
              "No hay cuotas ocultas. El costo es cero porque abres la cuenta con mi código, y te quedas el 100 % de tus resultados.",
            ],
          },
          results: {
            kicker: "RESULTADOS REALES · 1 AÑO Y 9 MESES",
            title: "21 meses de ganancia sostenida.",
            text: "Esta es la curva de resultados de la estrategia durante 1 año y 9 meses: 21 meses consecutivos de ganancia, con la gestión de riesgo trabajando en cada operación. Una sola curva de equity, su drawdown máximo bajo control y el número de operaciones encima de la mesa. Lo que ves es lo que hay.",
            stats: [
              { label: "GANANCIA TOTAL", value: "+1.572%" },
              { label: "RESULTADO", value: "+$157.218" },
              { label: "OPERACIONES GANADAS", value: "69,03%" },
              { label: "780 de 1.130 trades", value: "780 / 1.130" },
              { label: "PROFIT FACTOR", value: "1,95" },
              { label: "MÁX. DRAWDOWN", value: "11,53%" },
            ],
            image: {
              src: "/media/copytrading/resultados-19-meses.jpg",
              alt: "Curva de resultados de la estrategia CopyTrading en 1 año y 9 meses",
              label: "CURVA DE EQUITY · 1 AÑO Y 9 MESES",
              caption: "Curva de resultados de la estrategia en Oro durante 1 año y 9 meses. Un drawdown máximo del 11,53 % sobre una ganancia del 1.572 %: el resultado de aplicar un riesgo del 0,7 % en cada entrada, sin excepciones.",
            },
            note: "Los resultados se muestran sobre un capital de referencia de $10.000. El dato real de hoy lo tienes en el historial de Myfxbook, operación por operación.",
          },
          faq: {
            kicker: "PREGUNTAS FRECUENTES",
            title: "Lo que me preguntan siempre.",
            items: [
              { q: "¿Cuánto cuesta?", a: "Nada. El CopyTrading es gratis para quienes abren su cuenta de Roboforex con mi código de referido. No hay cuota mensual ni comisión sobre tus resultados." },
              { q: "¿Cuánto necesito para empezar?", a: "Un mínimo de $100 en una cuenta MT5 ProCent. Si quieres una versión con más riesgo por operación, hay una segunda estrategia con mínimo de $500." },
              { q: "¿Necesito tener la PC encendida o un VPS?", a: "No. Tu cuenta está conectada al servidor de Roboforex: no dependes de tu ordenador ni de tener MetaTrader abierto." },
              { q: "¿Puedo desconectarme cuando quiera?", a: "Sí. Puedes pausar el copiado o desconectar la cuenta en cualquier momento desde tu panel. Sin contratos ni permanencia." },
              { q: "¿Qué pasa si una operación sale en pérdida?", a: "La gestión de riesgo la cubre: cada operación se abre con un riesgo del 0,7 % del balance, así que una pérdida individual no compromete la cuenta ni el ciclo. Es precisamente lo que permite que la curva siga creciendo mes a mes durante 21 meses seguidos." },
              { q: "¿Puedo elegir el tamaño de mis operaciones?", a: "Sí. Tú decides el lote. El copiado es proporcional: si pones más balance, las operaciones se escalan contigo." },
              { q: "¿Se me puede quemar la cuenta?", a: "No. La estrategia está construida para que eso no ocurra: el riesgo por operación está fijado en el 0,7 % del balance y cada entrada lleva su Stop Loss definido antes de abrir. Con esa exposición por trade, ninguna operación ni racha de operaciones puede llevarse el balance entero. La protección del capital es el principio de diseño de la estrategia, y los 21 meses de resultados lo respaldan." },
              { q: "¿Usa Martingala o Grid?", a: "No. Nunca. Cada entrada lleva su Stop Loss y su riesgo acotado al 0,7 %; no se duplica posición para rescatar una operación. Es exactamente lo contrario de Grid y Martingala, y es lo que mantiene la curva de resultados sólida desde hace 21 meses." },
            ],
          },
          final: {
            title: "Empieza a copiar mis operaciones.",
            text: "Ábrete la cuenta con mi código, avísame por Telegram y en el mismo día conectamos tu cuenta al copiado. En cuanto esté conectada, empiezas a operar con la misma estrategia que lleva 21 meses dando resultados.",
            cta_label: "Escribirme por Telegram",
            cta_href: "https://t.me/TheMarketKilla",
            cta2_label: "Abrir cuenta en Roboforex",
            cta2_href: "https://my.roboforex.com/en/?a=emvr",
          },
          others_label: "OTROS SERVICIOS",
        },
        breakouts: {
          seo: {
            title: "Robot BreakOuts para MT5 — Forex, Oro e Índices | TheMarketKilla",
            description: "Mi robot de MT5: entra en cada ruptura a favor, multipar, Stop Loss bajo estructura, BreakEven y TrailingStop. Nunca Grid ni Martingala. Pasó FTMO 100 %.",
          },
          kicker: "ROBOT · MT5 · MULTIPAR",
          title_a: "El robot que entra en cada",
          title_b: "ruptura a favor.",
          lead: "BreakOuts es mi EA de MetaTrader 5 en piloto automático. Lee la tendencia en varias temporalidades y entra en cada ruptura a favor, con Stop Loss bajo la estructura. Opera hasta 8 pares simultáneos desde un solo gráfico. Con él pasé un challenge de FTMO al 100 % — y nunca usa Grid ni Martingala. Se instala una vez y opera solo, sin que tengas que mirar el gráfico.",
          nav_label: "Robot BreakOuts",
          cta_label: "Quiero el robot",
          cta_href: "https://t.me/TheMarketKilla",
          cta2_label: "Ver el Myfxbook del robot",
          cta2_href: "https://www.myfxbook.com/members/TheMarketKilla/themarketkilla-breakout-killa-premium/11918605",
          facts: [
            { label: "Mercados", value: "Forex · Oro" },
            { label: "Pares", value: "Hasta 8" },
            { label: "Licencia", value: "Gratis o $200" },
            { label: "Grid", value: "Nunca" },
          ],
          aside: {
            title: "Cómo se consigue",
            price: "GRATIS",
            price_note: "o $200 licencia premium",
            items: [
              "Gratis con cuenta Roboforex o Tickmill (referido)",
              "Premium: pago único de $200, cualquier broker · licencias ilimitadas",
              "El robot es el mismo archivo: solo cambia la licencia",
              "Multipar: hasta 8 pares simultáneos desde un gráfico",
              "Riesgo por operación configurable (0,5 %–1,5 % en fondeo)",
              "Perfecto para fondeo: FTMO / FundedNext",
            ],
            note: "Con cuenta de fondeo, la recomendación es riesgo 0,5 %–1 % por operación: el robot entra en cada challenge con la protección del capital por delante.",
          },
          how: {
            kicker: "CÓMO FUNCIONA",
            title: "Tendencia, ruptura y gestión automática.",
            items: [
              { n: "01", t: "Tendencia multi-timeframe", d: "El robot lee la tendencia en varias temporalidades a la vez. Solo opera a favor: en un mercado alcista busca entradas largas, y al contrario. Nunca rema contra la corriente." },
              { n: "02", t: "Entra en la ruptura", d: "Cuando el precio rompe un nivel relevante a favor de la tendencia, entra. El Stop Loss va bajo la estructura, no en un punto arbitrario: cada operación nace protegida." },
              { n: "03", t: "BreakEven y Trailing", d: "Al moverse a favor, protege la posición con BreakEven y deja correr la ganancia con TrailingStop. Nunca promedia a la pérdida, nunca Grid ni Martingala." },
              { n: "04", t: "Multipar sin gráficos extra", d: "Con un solo gráfico detecta solo los símbolos disponibles (~23) y opera hasta 8 pares simultáneos. Detecta el horario GMT automáticamente: tú no configuras nada." },
              { n: "05", t: "Anti-baneo por diseño", d: "No dispara cientos de operaciones por día: espera la ruptura, entra una sola vez por movimiento y respeta el spread. Por eso se mantiene sano en cuentas reales y en empresas de fondeo." },
              { n: "06", t: "Re-entra solo a favor", d: "Si el movimiento continúa, el robot vuelve a entrar a favor de la tendencia — nunca contra ella ni sumando a una operación en pérdida. Así aprovecha cada impulso al máximo." },
            ],
          },
          steps: {
            kicker: "CÓMO SE INSTALA",
            title: "De la compra a operando, en 4 pasos.",
            items: [
              { n: "1", t: "Me escribes", d: "Me dices si vas por la licencia gratis (con cuenta Roboforex o Tickmill) o por la premium de $200." },
              { n: "2", t: "Recibes los 3 archivos", d: "Te envío el EA (.ex5) más los dos indicadores que usa: ArrowZigZag y SuperTrend." },
              { n: "3", t: "Los instalas en MT5", d: "El robot va en MQL5/Experts y los indicadores en MQL5/Indicators. Te paso la guía paso a paso." },
              { n: "4", t: "Activas AutoTrading", d: "Arrastras el robot a un gráfico, activas AutoTrading y verificas que aparezca la licencia aprobada en la pestaña Experts. Listo." },
            ],
            footnote: "Si tienes cualquier problema al instalarlo (Wine, Mac, rutas de MQL5, licencia), escríbeme: lo resolvemos contigo. Tengo soporte técnico para MT5.",
          },
          proof: {
            kicker: "PRUEBAS · FTMO, FUNDEDNEXT, E8 Y MYFXBOOK",
            title: "Challenges pasados. Historial certificado.",
            text: "Toda la prueba del robot es real y la puedes auditar tú mismo: la cuenta real certificada en Myfxbook y los challenges de FTMO, FundedNext y E8 que el robot pasó operando solo, sin manos humanas. No es uno: son muchos, y cada uno con su certificado y su historial público.",
            shots: [
              { src: "/media/breakouts/gal-myfxbook-breakout-killa.jpg", alt: "Perfil de Myfxbook de la cuenta real Tickmill del robot BreakOuts", label: "CUENTA REAL · TICKMILL" },
              { src: "/media/breakouts/gal-ftmo-certificado.jpg", alt: "Certificado PASSED VERIFICATION de FTMO", label: "FTMO · PASSED 100 %" },
              { src: "/media/breakouts/gal-myfxbook-ftmo-phase1.jpg", alt: "Myfxbook del FTMO Challenge Phase 1", label: "FTMO · PHASE 1 · +10,27 %" },
              { src: "/media/breakouts/gal-fundednext-certificado.jpg", alt: "Certificado ELITE TRADER de FundedNext", label: "FUNDEDNEXT · ELITE TRADER" },
              { src: "/media/breakouts/gal-myfxbook-fundednext.jpg", alt: "Myfxbook del challenge de FundedNext operado por el robot", label: "FUNDEDNEXT · CHALLENGE" },
              { src: "/media/breakouts/gal-e8-certificado.jpg", alt: "Certificado de Performance de E8 Markets", label: "E8 MARKETS · APROBADO" },
            ],
            video: {
              src: "/media/breakouts/breakouts-lib.mp4",
              poster: "/media/breakouts/breakouts-lib.jpg",
              label: "EL ROBOT OPERANDO EN VIVO",
              caption: "Cuenta real multi-par con el robot operando: 4 gráficos a la vez, cada posición con su Stop Loss y las ganancias sumando solas. El balance sube mientras tú no tocas nada.",
              alt: "Cuenta real MT5 con el robot BreakOuts operando 4 gráficos a la vez",
            },
            links: [
              { label: "MYFXBOOK · CUENTA REAL", text: "Historial completo de la cuenta Tickmill operada por el robot.", href: "https://www.myfxbook.com/members/TheMarketKilla/themarketkilla-breakout-killa-premium/11918605" },
              { label: "PERFIL MYFXBOOK", text: "Todas las cuentas verificadas de TheMarketKilla.", href: "https://www.myfxbook.com/members/TheMarketKilla" },
            ],
            disclaimer: "Cada cifra sale de cuentas con historial público: puedes abrir los enlaces y comprobarlo operación por operación, hoy mismo. El robot trabaja con Stop Loss en cada entrada y riesgo definido antes de operar: la protección del capital es el principio de diseño.",
          },
          honest: {
            kicker: "SIN VENDERTE HUMO",
            title: "Lo que hace a este robot distinto.",
            items: [
              "Pasa challenges de fondeo operando solo. FTMO, FundedNext, E8: el robot entra, gestiona cada operación y los aprueba sin que toques nada. Tú recibes el certificado.",
              "Lo que ves aquí es un challenge aprobado hoy y otro mañana. La lista sigue creciendo, y cada uno queda con su historial público para que lo audites.",
              "Riesgo definido en cada entrada. Stop Loss puesto en el momento de abrir y riesgo acotado antes de operar: la protección del capital va por delante de la rentabilidad. Sin Grid, sin Martingala, sin cuentas reventadas.",
              "Opera varios pares a la vez. Hasta 8 posiciones simultáneas en gráficos distintos, así que no depende de un solo mercado ni de un solo acierto.",
              "Tu parte son dos minutos. No necesitas saber programar ni mirar gráficos: arrastras el archivo a MT5, activas AutoTrading y el robot trabaja por ti desde ahí.",
              "Cuenta real, no demo. La cuenta Tickmill operada por el robot está certificada en Myfxbook y la puedes ver en vivo, operación por operación.",
              "Una licencia, todos los gráficos que quieras. Con la premium cubres todas tus cuentas, en cualquier broker, con un solo pago.",
            ],
          },
          results: {
            kicker: "RESULTADO REAL · FTMO CHALLENGE",
            title: "Otro challenge pasado al 100 % operando solo.",
            text: "El robot pasó el challenge de FTMO de una cuenta de $10.000, gestionando cada entrada con su Stop Loss y su riesgo acotado. Ganancia del 10,27 % con un drawdown del 7,05 %: la protección del capital delante, la rentabilidad detrás.",
            stats: [
              { label: "GANANCIA", value: "+10,27 %" },
              { label: "DRAWDOWN MÁX.", value: "7,05 %" },
              { label: "ACIERTOS", value: "62 %" },
              { label: "PROFIT FACTOR", value: "1,69" },
              { label: "OPERACIONES", value: "37" },
              { label: "CERTIFICADO", value: "PASSED" },
            ],
            image: {
              src: "/media/breakouts/myfxbook-ftmo-phase1.jpg",
              alt: "Curva de resultados del FTMO Challenge operado por el robot BreakOuts",
              label: "FTMO CHALLENGE 1 · PHASE 1",
              caption: "Curva de crecimiento del challenge en Myfxbook: la equidad sube de forma constante hasta cerrar el objetivo. Cuenta demo de FTMO operada solo por el robot.",
            },
            note: "Las cifras se muestran tal como aparecen en Myfxbook, con el historial público disponible para auditarlas cuando quieras.",
          },
          faq: {
            kicker: "PREGUNTAS FRECUENTES",
            title: "Lo que más preguntan del robot.",
            items: [
              { q: "¿Cuánto cuesta?", a: "Tiene dos vías: gratis, si abres una cuenta en Roboforex o Tickmill con mi código (Pro·Classic); o premium, con un pago único de $200 y licencias ilimitadas en cualquier broker, sin depender de ningún referido." },
              { q: "¿Necesito saber programar?", a: "No. Solo arrastrar el archivo a la carpeta de MT5 y activarlo en un gráfico. Te paso los 3 archivos y la guía paso a paso. Dos minutos y está operando." },
              { q: "¿Con cuánto capital puedo empezar?", a: "Con lo que quieras, siempre que respetes el riesgo por operación. Para fondeo, la recomendación es 0,5 %–1,5 % por trade: así el robot entra en cada challenge con la protección del capital por delante." },
              { q: "¿Usa Grid o Martingala?", a: "Nunca. Esa es una de las reglas del sistema: sin promediar a la pérdida, sin duplicar lotes. Cada entrada lleva su Stop Loss y su riesgo definido antes de abrir." },
              { q: "¿En qué broker funciona?", a: "En cualquier MT5 con licencia premium. Para la licencia gratis, debe ser una cuenta de Roboforex o de Tickmill (Pro·Classic)." },
              { q: "¿Sirve para pasar cuentas de fondeo?", a: "Sí, es uno de sus usos principales: FTMO y FundedNext están entre las firmas con las que el robot ya pasó challenges operando solo. La clave es el riesgo: 0,5 %–1,5 % por operación." },
              { q: "¿Puedo usarlo en varias cuentas?", a: "Cada cuenta necesita su propia licencia. Con la premium puedes cubrir todas las que quieras, en cualquier broker, con un solo pago. Escríbeme y te digo cómo funciona según tu caso." },
            ],
          },
          final: {
            title: "Pon el robot a operar.",
            text: "Me escribes, te digo cuál de las dos licencias te conviene según tu caso y te paso los archivos con la guía de instalación. Hoy mismo puedes tenerlo trabajando en tu cuenta.",
            cta_label: "Quiero el robot",
            cta_href: "https://t.me/TheMarketKilla",
            cta2_label: "Ver el Myfxbook del robot",
            cta2_href: "https://www.myfxbook.com/members/TheMarketKilla/themarketkilla-breakout-killa-premium/11918605",
          },
          others_label: "OTROS SERVICIOS",
        },
        bullrun: {
          seo: {
            title: "Bull Run 2026 — Grupo privado de inversión cripto (10 plazas) | TheMarketKilla",
            description: "Grupo privado de 10 personas para recorrer el ciclo alcista cripto: qué acumular, cuándo comprar y cuándo vender. Pago único $490.",
          },
          kicker: "BULL RUN 2026 · GRUPO PRIVADO",
          title_a: "El ciclo alcista se recorre",
          title_b: "con guía, no a ciegas.",
          lead: "Un grupo privado que abro una vez cada cuatro años, justo antes del bull run. Trabajamos mano a mano con solo 10 personas durante todo el ciclo alcista: te digo en qué monedas entrar, cuándo comprar y cuándo vender, con análisis técnico y fundamental. Tú mantienes siempre el control de tu capital.",
          nav_label: "Bull Run 2026",
          cta_label: "Reservar mi plaza",
          cta_href: "https://t.me/TheMarketKilla",
          cta2_label: "Escribirme por Telegram",
          cta2_href: "https://t.me/TheMarketKilla",
          facts: [
            { label: "Plazas", value: "Solo 10" },
            { label: "Duración", value: "Todo el ciclo" },
            { label: "Proyectos", value: "+20" },
            { label: "Pago", value: "$490 único" },
          ],
          aside: {
            title: "La ficha",
            price: "$490",
            price_note: "pago único, todo el ciclo",
            items: [
              "Grupo privado, solo 10 personas",
              "Estrategia diversificada en +20 proyectos",
              "Análisis técnico y fundamental de cada moneda",
              "Acompañamiento paso a paso: entrada, compra y salida",
              "Tú operas desde tu propia wallet",
              "Cubre todo el ciclo: 6 meses a 1 año",
            ],
            note: "El objetivo es multiplicar el capital (x20 o más) como en ciclos anteriores. Es un objetivo, no una garantía: nadie puede prometerte eso en cripto.",
          },
          how: {
            kicker: "CÓMO FUNCIONA",
            title: "Una estrategia, veinte proyectos, diez personas.",
            items: [
              { n: "01", t: "Selección de 20 proyectos", d: "Cada moneda entra a la lista tras un análisis profundo, técnico y fundamental. Nada de 'moonshots' de moda: proyectos con tesis." },
              { n: "02", t: "Diversificación real", d: "En lugar de jugarte todo a uno, el capital se reparte entre al menos 20 proyectos. Así un error no se lleva la cartera entera." },
              { n: "03", t: "Entradas y salidas guiadas", d: "Te indico en qué monedas entrar, en qué momento comprar, cuándo tomar beneficio y cuándo salir. Sin dejarte adivinar." },
              { n: "04", t: "Tu wallet, tu control", d: "Nunca toco tu dinero. Compras y vendes desde tu propia wallet, con tus claves. Yo guío; tú decides y ejecutas." },
              { n: "05", t: "Acompañamiento todo el ciclo", d: "No es un curso que termina. Estoy contigo durante el ciclo completo, hasta que vendamos las posiciones con el objetivo cumplido." },
              { n: "06", t: "Solo 10 personas", d: "El límite existe para poder responderle a cada uno. Cuando se llenan las plazas, el grupo se cierra hasta el próximo ciclo." },
            ],
          },
          steps: {
            kicker: "CÓMO ENTRAR",
            title: "Cuatro pasos para asegurar tu plaza.",
            items: [
              { n: "1", t: "Me escribes", d: "Me cuentas tu situación y qué capital piensas destinar al ciclo. Sin compromiso." },
              { n: "2", t: "Confirmo la plaza", d: "Te digo si quedan plazas disponibles (son solo 10) y si el grupo encaja con lo que buscas." },
              { n: "3", t: "Pago único de $490", d: "Se abona una sola vez y cubre todo el ciclo, hasta la venta de las posiciones. Sin mensualidades." },
              { n: "4", t: "Entras al grupo", d: "Te agrego al grupo privado por invitación y empezamos a trabajar en la estrategia." },
            ],
            footnote: "Si el grupo ya estuviera completo, te aviso y te dejo en la lista del próximo ciclo. No vendo plazas que no existen.",
          },
          proof: {
            kicker: "POR QUÉ 10 PLAZAS",
            title: "La exclusividad es por atención, no por marketing.",
            text: "Con 10 personas puedo leerle a cada una su situación, responder a sus dudas y ajustar la guía a su capital. Con 300, esto sería un canal de señales más. La prueba de que el trabajo se hace bien es el trato uno a uno durante todo el ciclo.",
            shots: [],
            video: null,
            links: [],
            disclaimer: null,
          },
          honest: {
            kicker: "SIN VENDERTE HUMO",
            title: "Lo que este grupo NO es.",
            items: [
              "No es gestión de tu dinero: nadie toca tu capital. Operas tú, desde tu propia wallet.",
              "No es una garantía del x20. Es el objetivo con el que trabajo, basado en ciclos anteriores.",
              "No es un curso grabado ni un canal de señales de compra y venta de corto plazo.",
              "No es para todos: si no puedes sostener la volatilidad de un ciclo cripto completo, no es tu sitio.",
            ],
          },
          faq: {
            kicker: "PREGUNTAS FRECUENTES",
            title: "Lo que preguntan antes de entrar.",
            items: [
              { q: "¿Cuánto cuesta?", a: "Pago único de $490. Cubre todo el ciclo alcista, hasta que vendamos las posiciones con el objetivo cumplido. Sin mensualidades." },
              { q: "¿Cuándo abre el grupo?", a: "Una sola vez cada cuatro años, antes del bull run. Ahora mismo está abierto: los interesados todavía están a tiempo." },
              { q: "¿Cuántas personas entran?", a: "Solo 10. El límite es para poder responderle a cada uno de forma personal durante todo el ciclo." },
              { q: "¿Ustedes manejan mi dinero?", a: "No, nunca. Tú tienes el control total: todo se hace desde tu propia wallet, con tus claves. Yo solo guío." },
              { q: "¿Cuánto puedo ganar?", a: "El objetivo es multiplicar el capital x20 o más, como en ciclos anteriores. Es un objetivo, no una garantía." },
              { q: "¿Cuánto dura?", a: "Todo el ciclo alcista, aproximadamente entre 6 meses y un año, según cómo se desarrolle el mercado." },
              { q: "¿Necesito saber de cripto?", a: "No es imprescindible, pero sí hay que saber comprar y vender en una plataforma. Te guío en lo demás, incluido en qué plataformas operar." },
            ],
          },
          final: {
            title: "Quedan plazas para este ciclo.",
            text: "El grupo se abre una vez cada cuatro años y son diez personas. Si te interesa, escríbeme ahora y te confirmo si todavía hay lugar.",
            cta_label: "Reservar mi plaza",
            cta_href: "https://t.me/TheMarketKilla",
            cta2_label: "Escribirme por Telegram",
            cta2_href: "https://t.me/TheMarketKilla",
          },
          others_label: "OTROS SERVICIOS",
        },
        senales: {
          seo: {
            title: "Señales de trading — Forex, Cripto, Índices y Metales | TheMarketKilla",
            description: "De 2 a 10 señales por semana con Stop Loss estricto, Take Profit, BreakEven y TrailingStop. Forex, Cripto, Índices y Metales. Desde $30/mes.",
          },
          kicker: "SEÑALES · FOREX · CRIPTO · ÍNDICES",
          title_a: "Cada señal con su Stop Loss",
          title_b: "y su plan de salida.",
          lead: "Señales de trading para Forex, Cripto, Índices y Metales, pensadas tanto para cuentas personales como para empresas de fondeo. No es una entrada suelta en un chat: cada señal llega con entrada, Stop Loss estricto, Take Profit, BreakEven y TrailingStop, para que sepas exactamente cómo gestionarla.",
          nav_label: "Señales",
          cta_label: "Anotarme en la lista",
          cta_href: "https://t.me/TheMarketKilla",
          cta2_label: "Escribirme por Telegram",
          cta2_href: "https://t.me/TheMarketKilla",
          facts: [
            { label: "Mercados", value: "4 clases" },
            { label: "Frecuencia", value: "2–10/sem" },
            { label: "Gestión", value: "SL + TP" },
            { label: "Desde", value: "$30/mes" },
          ],
          aside: {
            title: "Planes",
            price: "$30",
            price_note: "al mes · hay planes más largos",
            items: [
              "Mensual: $30/mes",
              "Trimestral: $75 (~$25/mes, ahorras ~17 %)",
              "Semestral: $135 (~$22,50/mes, ahorras 25 %)",
              "Anual: $240 (~$20/mes, ahorras ~33 %)",
              "Ilimitado: $490 una sola vez",
              "Cada señal incluye SL + TP + BreakEven + TrailingStop",
            ],
            note: "Servicio en preparación: los planes y precios ya están definidos. Muy pronto. La lista se cierra por orden de llegada.",
          },
          how: {
            kicker: "CÓMO FUNCIONA",
            title: "De 2 a 10 señales por semana, con gestión de riesgo.",
            items: [
              { n: "01", t: "Selección semanal", d: "De 2 a 10 señales por semana entre Forex, Cripto, Índices y Metales. Pocas y elegidas: nada de saturar con 40 entradas." },
              { n: "02", t: "Entrada y Stop Loss claro", d: "Cada señal trae el punto de entrada y un Stop Loss estricto, definido antes de abrir. Sabes desde el inicio cuánto arriesgas." },
              { n: "03", t: "Take Profit y BreakEven", d: "Además del TP, la señal indica cuándo mover a BreakEven para quitarle riesgo a la operación en cuanto el mercado se mueve a favor." },
              { n: "04", t: "TrailingStop", d: "Indicaciones para dejar correr la operación con TrailingStop, capturando más recorrido sin devolver el beneficio ya ganado." },
              { n: "05", t: "Apta para fondeo", d: "La gestión de riesgo está pensada para cuentas personales y de empresas de fondeo, donde un exceso de riesgo descalifica." },
              { n: "06", t: "Entrega por canal privado", d: "Las señales se entregan por canal privado de Telegram, en el momento de la entrada, con todos los parámetros." },
            ],
          },
          steps: {
            kicker: "CÓMO SE EMPIEZA",
            title: "Se está preparando. Así entrarás.",
            items: [
              { n: "1", t: "Anótate en la lista", d: "Ahora mismo el servicio está en preparación. Escríbeme y te dejo anotado para avisarte apenas abra." },
              { n: "2", t: "Eliges plan", d: "Cuando abra, eliges el plan: $30/mes, $75 trimestral, $135 semestral, $240 anual o $490 ilimitado." },
              { n: "3", t: "Entras al canal", d: "Se te da acceso al canal privado de entrega de señales." },
              { n: "4", t: "Operas cada señal", d: "Recibes la entrada, el Stop Loss, el Take Profit y las indicaciones de BreakEven y TrailingStop. Ejecutas y gestionas." },
            ],
            footnote: "Si te anotas ahora, tienes prioridad cuando abramos: la lista se cierra por orden de llegada.",
          },
          proof: {
            kicker: "ESTADO DEL SERVICIO",
            title: "Todavía no está lanzado.",
            text: "Preferimos decirlo claro: el servicio de señales está en preparación y aún no se ha lanzado. Lo que define el servicio ya está cerrado, pero prefiero avisarte y que entres cuando esté funcionando de verdad, no venderte el acceso antes de tiempo. Si me escribes, te dejo anotado y te aviso el día que abra.",
            shots: [],
            video: null,
            links: [],
            disclaimer: null,
          },
          honest: {
            kicker: "SIN VENDERTE HUMO",
            title: "Lo que este servicio NO es.",
            items: [
              "No es un grupo de 'señales infalibles': ninguna señal garantiza ganar. Por eso cada una lleva su Stop Loss.",
              "No es un robot: las señales las operas tú manualmente, siguiendo los parámetros.",
              "No prometo un número de ganancias al mes. El compromiso es el proceso: SL estricto y gestión disciplinada.",
              "No está abierto todavía: te aviso cuando lo esté, en lugar de cobrarte por adelantado.",
            ],
          },
          faq: {
            kicker: "PREGUNTAS FRECUENTES",
            title: "Lo que preguntan de las señales.",
            items: [
              { q: "¿Ya está disponible?", a: "Todavía no: el servicio está muy pronto. Puedes anotarte en la lista y te aviso apenas abra." },
              { q: "¿Qué mercados cubre?", a: "Forex, Cripto, Índices y Metales. Cuatro clases de activo, con foco en las mejores oportunidades de la semana." },
              { q: "¿Cuántas señales llegan por semana?", a: "Entre 2 y 10. La idea es la calidad sobre la cantidad: pocas entradas bien elegidas en lugar de ruido constante." },
              { q: "¿Qué incluye cada señal?", a: "Entrada, Stop Loss estricto y claro, Take Profit e indicaciones de BreakEven y TrailingStop. Todo con parámetros concretos." },
              { q: "¿Sirve para cuentas de fondeo?", a: "Sí, está pensado también para empresas de fondeo. La gestión de riesgo sigue los límites que ese tipo de cuentas exige." },
              { q: "¿Cuánto cuesta?", a: "Desde $30/mes. También hay trimestral ($75), semestral ($135), anual ($240) e ilimitado de por vida ($490)." },
              { q: "¿Por dónde llegan las señales?", a: "Por canal privado de Telegram, con todos los parámetros de entrada y gestión. Te doy el acceso al activar tu plan." },
            ],
          },
          final: {
            title: "Anótate antes de que abra.",
            text: "El servicio está en preparación y la lista se cierra por orden de llegada. Escríbeme y te aviso el día que empiece a funcionar.",
            cta_label: "Anotarme en la lista",
            cta_href: "https://t.me/TheMarketKilla",
            cta2_label: "Escribirme por Telegram",
            cta2_href: "https://t.me/TheMarketKilla",
          },
          others_label: "OTROS SERVICIOS",
        },
      },
    },
    pricing: {
      kicker: "ACCESOS",
      title: "Cada servicio, su precio.",
      subtitle:
        "Sin suscripciones atadas ni planes que no uso. Lo que cuesta cada cosa es lo que ves.",
      mo: "/mes",
      once: "pago único",
      most: "MÁS ELEGIDO",
      cta: "Escríbeme por Telegram",
      tier_cta: "Ver el servicio",
      hire_cta: "Contratar ahora",
      tiers: [
        {
          name: "COPYTRADING",
          price: "GRATIS",
          tagline: "Solo con mi código de referido",
          features: [
            "Copia automática de mis operaciones",
            "Scalping en Oro (XAUUSD)",
            "Cuenta Master transparente",
            "Mínimo $100 en tu cuenta",
            "Sin cuotas ni mensualidades",
          ],
          note: "Gratis para todos los referidos de Roboforex. Sin cuotas ni mensualidades.",
        },
        {
          name: "ROBOT BREAKOUTS",
          price: "$200",
          price_was: "$490",
          discount: "AHORRAS $290 · -59%",
          tagline: "Licencia premium · cualquier broker",
          features: [
            "El robot en tu MT5, multipar",
            "Stop bajo estructura + BreakEven + Trailing",
            "Sin Grid ni Martingala",
            "Sirve para fondeo (FTMO/FundedNext)",
            "Pago único, tuyo para siempre",
          ],
          note: "Oferta por tiempo limitado. Con cuenta Roboforex o Tickmill (Pro·Classic) y mi código, la licencia sale gratis.",
        },
        {
          name: "BULL RUN 2026",
          price: "$490",
          tagline: "Grupo privado · solo 10 plazas",
          features: [
            "Ruta guiada por el ciclo alcista",
            "Qué acumular y por qué, con visión macro",
            "Rebalanceo táctico sobre la marcha",
            "Acceso directo a mí, uno por uno",
            "Pago único, sin mensualidades",
          ],
          note: "Solo 10 personas: cuando se llenan, se cierra.",
        },
        {
          name: "SEÑALES",
          price: "Desde $30",
          tagline: "Forex · Crypto · Índices · Metales",
          features: [
            "2-10 señales por semana",
            "Stop Loss estricto en cada entrada",
            "Take Profit, BreakEven y TrailingStop",
            "Entrega directa por Telegram",
            "$30/mes · $75/3m · $135/6m · $240/12m",
          ],
          note: "🕒 Muy pronto. La lista se cierra por orden de llegada.",
        },
      ],
    },
    contact: {
      kicker: "CONTACTO",
      title: "Háblame directo.",
      subtitle:
        "Sin formularios ni intermediarios. Me escribes por Telegram, me cuentas qué buscas y te digo si puedo ayudarte.",
      telegram: "Escribirme al privado",
      channel: "Entrar al canal",
      panel_title: "Un mensaje y hablamos.",
      panel_text:
        "Me cuentas qué buscas — copiar mis operaciones, el robot, el grupo del Bull Run o las señales — y te digo con franqueza si encaja contigo. Sin formularios, sin esperas, sin comerciales de por medio.",
      email_label: "Email",
      cards: {
        dm: { label: "TELEGRAM", value: "@TheMarketKilla" },
        channel: { label: "CANAL", value: "The_Market_Killa" },
        email: { label: "EMAIL", value: "themarketkilla@hotmail.com" },
      },
      note: "Respondo yo, no un bot. Si no te contesto al instante, es porque estoy frente al gráfico.",
    },
    footer: {
      tagline: "+10 años operando. +500 estrategias programadas.",
      legal: "TheMarketKilla no es una sociedad constituida. Los datos de la cuenta Master se publican en abierto.",
      copy: "Todos los derechos reservados.",
      channels: "CANALES",
      contact: "CONTACTO",
      nav: "NAV",
      terms: "Términos",
      privacy: "Privacidad",
      copyCanal: "Entrar al canal de CopyTrading",
      roboforex: "Abrir cuenta en Roboforex",
    },
  },
  en: {
    nav: {
      services: "Services",
      markets: "Markets",
      pricing: "Access",
      contact: "Contact",
      cta: "Message me",
    },
    hero: {
      kicker: "AUTOMATED TRADING · FOREX · GOLD · CRYPTO",
      title_a: "The system trades.",
      title_b: "By rules, not emotion.",
      subtitle:
        "+10 years trading Forex, Gold and Crypto. +500 strategies programmed. Robots running the same discipline as always — 24/5, without hesitation, without greed.",
      cta_primary: "See how it works",
      cta_secondary: "Live markets",
      stat_a: "Years in the markets",
      stat_b: "Strategies programmed",
      stat_c: "FTMO Challenge passed",
    },
    ticker: { live: "LIVE" },
    markets: {
      kicker: "DATA · BINANCE · REAL-TIME",
      title: "Market room",
      subtitle:
        "Spot prices straight from Binance's order book. BTC, ETH, XRP and tokenized gold (PAXG) — refreshed every 15 seconds.",
      change_24h: "24h",
      high: "24h High",
      low: "24h Low",
      vol: "Volume",
    },
    services: {
      kicker: "SERVICES · THEMARKETKILLA",
      title: "Four ways to trade with me. 👇",
      subtitle:
        "From the robot that works on its own to the group where we ride the bull cycle. Pick your entry.",
      card_cta: "See the full service",
      list: {
        copytrading: {
          tag: "01",
          title: "Gold CopyTrading",
          badge: "FREE",
          desc: "I copy my Gold (XAUUSD) scalping trades from a Master account. You just connect and set the lot size. Free if you open your Roboforex account with my code.",
          meta: "Roboforex · MT5 ProCent · $100 minimum",
        },
        breakouts: {
          tag: "02",
          title: "BreakOuts Robot",
          badge: "FREE OR $490",
          desc: "My MT5 robot: reads the trend and takes every breakout in its direction. Multi-pair, stop under structure, BreakEven and TrailingStop. Never Grid, never Martingale. It passed FTMO 100 %.",
          meta: "MT5 · Forex · Gold · Indices · Prop firms",
        },
        bullrun: {
          tag: "03",
          title: "Bull Run 2026",
          badge: "10 SPOTS",
          desc: "A private group to ride the bull cycle: what to accumulate and why, with macro vision and tactical rebalancing. Only 10 people, so I can answer each one personally.",
          meta: "One-time $490 · private group",
        },
        senales: {
          tag: "04",
          title: "Signals",
          badge: "COMING SOON",
          desc: "Forex, Crypto, Indices and Metals. 2 to 10 signals a week, each with a strict Stop Loss, Take Profit, BreakEven and TrailingStop. Delivered through a private channel.",
          meta: "From $30/month",
        },
      },
      page_nav_back: "All services",
      nav_label: "Services",
      pages: {
        copytrading: {
          seo: {
            title: "Gold CopyTrading (XAUUSD) — Free with Roboforex | TheMarketKilla",
            description: "My Gold scalping trades copied automatically to your account. Free with your Roboforex account. $100 minimum. Results audited on Myfxbook.",
          },
          kicker: "COPYTRADING · XAUUSD · ROBOROREX",
          title_a: "A winning Gold strategy,",
          title_b: "copied to your account.",
          lead: "I trade. You copy. My Gold (XAUUSD) scalping Master account mirrors every entry on your Roboforex account automatically: same Stop Loss, same Take Profit, same exit. No screen time, no VPS, no PC left on. Open the account with my code and the service is free.",
          nav_label: "Gold CopyTrading",
          cta_label: "Message me on Telegram",
          cta_href: "https://t.me/TheMarketKilla",
          cta2_label: "Open my Roboforex account",
          cta2_href: "https://my.roboforex.com/en/?a=emvr",
          facts: [
            { label: "Asset", value: "XAUUSD" },
            { label: "Account", value: "MT5 ProCent" },
            { label: "Minimum", value: "$100" },
            { label: "Cost", value: "FREE" },
          ],
          aside: {
            title: "The details",
            price: "FREE",
            price_note: "with my Roboforex code",
            items: [
              "Automatic copy of my trades",
              "Gold (XAUUSD) scalping, 5–30 min per trade",
              "My Master account, in the open",
              "Stop Loss on every entry. Never Grid or Martingale",
              "No fees, no subscriptions, no lock-in",
              "Limited spots (I run a single Master)",
            ],
            note: "The service is free because you open your account with my referral link. You keep 100 % of your results: your money never leaves your account.",
          },
          how: {
            kicker: "HOW IT WORKS",
            title: "Proportional copy, no middlemen.",
            items: [
              { n: "01", t: "My Master account", d: "I trade from a single Master account: Gold scalping with the Million's Strategy. Every entry has its Stop Loss defined before I open it, with a 0.7% risk per trade that keeps the curve steady month after month." },
              { n: "02", t: "Your account subscribes", d: "From the Roboforex panel you connect your account to the strategy. Copying is proportional to your balance, with the lot size you choose." },
              { n: "03", t: "Zero lag, fully automatic", d: "Same broker (Roboforex) means the copy travels between servers with no delay. Your account works on its own, 24/5." },
            ],
          },
          steps: {
            kicker: "HOW TO START",
            title: "From zero to copying, in 5 steps.",
            items: [
              { n: "1", t: "Open your account", d: "Sign up at Roboforex with my link (code emvr). It's free and takes a couple of minutes." },
              { n: "2", t: "Choose MT5 ProCent", d: "When creating the account pick MT5 ProCent and fund it from $100." },
              { n: "3", t: "Verify and deposit", d: "Complete the broker's verification and fund your account. $100 minimum to trade in proportion." },
              { n: "4", t: "Tell me", d: "Message me on Telegram with your account number. I send you the CopyTrading link." },
              { n: "5", t: "Connect and done", d: "Accept the copy request and set your lot size. From then on, every trade of mine is mirrored on your account." },
            ],
            footnote: "If a step gets stuck, message me and we sort it out together. It's your account, your broker and your money: you stay in control the whole way.",
          },
          proof: {
            kicker: "PROOF · MYFXBOOK CERTIFIED",
            title: "Results aren't claimed: they're verified.",
            text: "My Master account is monitored and certified by Myfxbook, the most widely used trade-verification platform in the industry. You can open the full history, trade by trade, whenever you want. The links are public and permanent.",
            shots: [
              { src: "/media/copytrading/myfxbook-master-1.jpg", alt: "Myfxbook widget for TheMarketKilla Master 1", label: "MASTER 1 · MYFXBOOK", caption: "Verified account. The percentage changes daily because the account is trading: that's why the link matters more than the number." },
              { src: "/media/copytrading/myfxbook-master-2.jpg", alt: "Myfxbook widget for TheMarketKilla Master 2", label: "MASTER 2 · MYFXBOOK", caption: "Second Master, also certified by Myfxbook. Same strategy, same risk discipline." },
            ],
            video: {
              src: "/media/copytrading/copytrading-lib.mp4",
              label: "COPYTRADING LIVE",
              caption: "Recording of the account trading in real time: entries, management and exits.",
            },
            links: [
              { label: "MASTER 1", text: "Full history, verified by Myfxbook.", href: "https://www.myfxbook.com/members/TheMarketKilla/themarketkilla-millions-strategy-1/12241336" },
              { label: "MASTER 2", text: "Second Master, also verified.", href: "https://www.myfxbook.com/members/TheMarketKilla/themarketkilla-millions-strategy-2/12241349" },
              { label: "MASTER ACCOUNT ON ROBOROREX", text: "Entry strategy from $100 (MT5 ProCent).", href: "https://my.roboforex.com/en/copy-trading/my/strategies/bbba/37393149/overview" },
              { label: "ROBOROREX · MT5 ACCOUNT", text: "Account type used for the copy.", href: "https://my.roboforex.com/en/?a=emvr" },
            ],
            disclaimer: "Figures and the curve update daily: each link shows today's data, not a brochure's. We trade with a Stop Loss on every entry and never use Grid or Martingale, with a maximum risk of 0.7% per trade: a risk model designed to protect capital in every cycle.",
          },
          honest: {
            kicker: "NO HYPE",
            title: "What this service is NOT.",
            items: [
              "It's not hype: every result you see is verified by Myfxbook and you can audit it yourself, trade by trade.",
              "No Grid, no Martingale. Every trade carries a Stop Loss and risk defined before entry: that's how capital is protected.",
              "Your money never passes through my hands: it stays in your Roboforex account, fully under your control.",
              "No hidden fees. The cost is zero because you open the account with my code, and you keep 100% of your results.",
            ],
          },
          results: {
            kicker: "REAL RESULTS · 1 YEAR 9 MONTHS",
            title: "21 months of sustained gain.",
            text: "This is the strategy's result curve over 1 year and 9 months: 21 consecutive months of gain, with risk management working on every trade. One equity curve, its maximum drawdown under control and the trade count on the table. What you see is what there is.",
            stats: [
              { label: "TOTAL GAIN", value: "+1,572%" },
              { label: "RESULT", value: "+$157,218" },
              { label: "WINNING TRADES", value: "69.03%" },
              { label: "780 of 1,130 trades", value: "780 / 1,130" },
              { label: "PROFIT FACTOR", value: "1.95" },
              { label: "MAX DRAWDOWN", value: "11.53%" },
            ],
            image: {
              src: "/media/copytrading/resultados-19-meses.jpg",
              alt: "CopyTrading strategy result curve over 1 year and 9 months",
              label: "EQUITY CURVE · 1 YEAR 9 MONTHS",
              caption: "Result curve for the Gold strategy over 1 year and 9 months. A maximum drawdown of 11.53% against a 1,572% gain: the outcome of applying 0.7% risk on every entry, without exception.",
            },
            note: "Results are shown on a $10,000 reference capital. Today's real figure is in the Myfxbook history, trade by trade.",
          },
          faq: {
            kicker: "FAQ",
            title: "What I get asked most.",
            items: [
              { q: "How much does it cost?", a: "Nothing. CopyTrading is free for anyone who opens their Roboforex account with my referral code. No monthly fee, no cut of your results." },
              { q: "How much do I need to start?", a: "A $100 minimum in an MT5 ProCent account. If you want a version with more risk per trade, there's a second strategy with a $500 minimum." },
              { q: "Do I need my PC on or a VPS?", a: "No. Your account is connected to Roboforex's servers: you don't depend on your computer or on having MetaTrader open." },
              { q: "Can I disconnect whenever I want?", a: "Yes. You can pause the copy or disconnect the account any time from your panel. No contracts, no lock-in." },
              { q: "What if a trade goes into loss?", a: "Risk management covers it: every trade opens with 0.7% of the balance at risk, so a single loss never compromises the account or the cycle. That's precisely what lets the curve keep growing month after month for 21 straight months." },
              { q: "Can I choose my trade size?", a: "Yes. You set the lot size. Copying is proportional: with more balance, the trades scale with you." },
              { q: "Can my account get blown?", a: "No. The strategy is built so that never happens: risk per trade is fixed at 0.7% of the balance and every entry carries its Stop Loss defined before opening. With that exposure per trade, no single trade or losing streak can take out the entire balance. Capital protection is the strategy's design principle, and 21 months of results back it up." },
              { q: "Does it use Martingale or Grid?", a: "No. Never. Every entry carries its Stop Loss and risk capped at 0.7%; no position is doubled to rescue a trade. It's the exact opposite of Grid and Martingale, and it's what has kept the result curve solid for 21 months." },
            ],
          },
          final: {
            title: "Start copying my trades.",
            text: "Open your account with my code, message me on Telegram and we connect your account to the copy the same day. Once connected, you start trading the same strategy that's been delivering results for 21 months.",
            cta_label: "Message me on Telegram",
            cta_href: "https://t.me/TheMarketKilla",
            cta2_label: "Open a Roboforex account",
            cta2_href: "https://my.roboforex.com/en/?a=emvr",
          },
          others_label: "OTHER SERVICES",
        },
        breakouts: {
          seo: {
            title: "BreakOuts Robot for MT5 — Forex, Gold & Indices | TheMarketKilla",
            description: "My MT5 robot: takes every breakout in the trend's direction, multi-pair, Stop Loss under structure, BreakEven and TrailingStop. Never Grid or Martingale. Passed FTMO 100 %.",
          },
          kicker: "ROBOT · MT5 · MULTI-PAIR",
          title_a: "The robot that takes every",
          title_b: "breakout in its favour.",
          lead: "BreakOuts is my fully automated MT5 EA. It reads the trend across timeframes and takes every breakout in its direction, with a Stop Loss under the structure. It trades up to 8 pairs simultaneously from a single chart. With it I passed an FTMO challenge 100 % — and it never uses Grid or Martingale. Install it once and it trades on its own, without you having to watch the chart.",
          nav_label: "BreakOuts Robot",
          cta_label: "I want the robot",
          cta_href: "https://t.me/TheMarketKilla",
          cta2_label: "See the robot's Myfxbook",
          cta2_href: "https://www.myfxbook.com/members/TheMarketKilla/themarketkilla-breakout-killa-premium/11918605",
          facts: [
            { label: "Markets", value: "Forex · Gold" },
            { label: "Pairs", value: "Up to 8" },
            { label: "License", value: "Free or $200" },
            { label: "Grid", value: "Never" },
          ],
          aside: {
            title: "How to get it",
            price: "FREE",
            price_note: "or $200 premium license",
            items: [
              "Free with a Roboforex or Tickmill account (referral)",
              "Premium: one-time $200, any broker · unlimited licenses",
              "Same robot file: only the license changes",
              "Multi-pair: up to 8 simultaneous pairs from one chart",
              "Configurable risk per trade (0.5 %–1.5 % for prop firms)",
              "Perfect for prop firms: FTMO / FundedNext",
            ],
            note: "On a prop-firm account the recommendation is 0.5 %–1 % risk per trade: the robot enters every challenge with capital protection first.",
          },
          how: {
            kicker: "HOW IT WORKS",
            title: "Trend, breakout and automatic management.",
            items: [
              { n: "01", t: "Multi-timeframe trend", d: "The robot reads the trend across several timeframes at once. It only trades with it: in an uptrend it looks for longs, and the other way round. It never fights the current." },
              { n: "02", t: "Enters on the breakout", d: "When price breaks a relevant level in the trend's direction, it enters. The Stop Loss sits under the structure, not at an arbitrary point: every trade is born protected." },
              { n: "03", t: "BreakEven and Trailing", d: "As the trade moves in favour, it protects the position with BreakEven and lets the profit run with a TrailingStop. It never averages a loser, never Grid or Martingale." },
              { n: "04", t: "Multi-pair, no extra charts", d: "From a single chart it detects the available symbols (~23) and trades up to 8 pairs simultaneously. It detects GMT hours automatically: nothing for you to configure." },
              { n: "05", t: "Anti-ban by design", d: "It doesn't fire hundreds of trades a day: it waits for the breakout, enters once per move and respects the spread. That's why it stays healthy on live accounts and with prop firms." },
              { n: "06", t: "Re-enters with the trend only", d: "If the move continues, it re-enters in the trend's direction — never against it, and never adding to a losing trade. That's how it makes the most of every impulse." },
            ],
          },
          steps: {
            kicker: "HOW TO INSTALL",
            title: "From purchase to trading, in 4 steps.",
            items: [
              { n: "1", t: "Message me", d: "Tell me whether you want the free license (with a Roboforex or Tickmill account) or the $200 premium." },
              { n: "2", t: "You get the 3 files", d: "I send you the EA (.ex5) plus the two indicators it uses: ArrowZigZag and SuperTrend." },
              { n: "3", t: "Install them in MT5", d: "The robot goes in MQL5/Experts and the indicators in MQL5/Indicators. I send you the step-by-step guide." },
              { n: "4", t: "Turn on AutoTrading", d: "Drag the robot onto a chart, enable AutoTrading and check that the approved license shows in the Experts tab. Done." },
            ],
            footnote: "If you have any trouble installing it (Wine, Mac, MQL5 paths, license), message me: we solve it together. I provide MT5 technical support.",
          },
          proof: {
            kicker: "PROOF · FTMO, FUNDEDNEXT, E8 AND MYFXBOOK",
            title: "Challenges passed. Certified history.",
            text: "All the robot's proof is real and you can audit it yourself: the live account certified on Myfxbook and the FTMO, FundedNext and E8 challenges the robot passed trading on its own, with no human hands. It's not one: it's many, each one with its certificate and its public history.",
            shots: [
              { src: "/media/breakouts/gal-myfxbook-breakout-killa.jpg", alt: "Myfxbook profile of the robot's real Tickmill account", label: "LIVE ACCOUNT · TICKMILL" },
              { src: "/media/breakouts/gal-ftmo-certificado.jpg", alt: "FTMO PASSED VERIFICATION certificate", label: "FTMO · PASSED 100 %" },
              { src: "/media/breakouts/gal-myfxbook-ftmo-phase1.jpg", alt: "Myfxbook of the FTMO Challenge Phase 1", label: "FTMO · PHASE 1 · +10.27 %" },
              { src: "/media/breakouts/gal-fundednext-certificado.jpg", alt: "FundedNext ELITE TRADER certificate", label: "FUNDEDNEXT · ELITE TRADER" },
              { src: "/media/breakouts/gal-myfxbook-fundednext.jpg", alt: "Myfxbook of the FundedNext challenge traded by the robot", label: "FUNDEDNEXT · CHALLENGE" },
              { src: "/media/breakouts/gal-e8-certificado.jpg", alt: "E8 Markets Certificate of Performance", label: "E8 MARKETS · APPROVED" },
            ],
            video: {
              src: "/media/breakouts/breakouts-lib.mp4",
              poster: "/media/breakouts/breakouts-lib.jpg",
              label: "THE ROBOT TRADING LIVE",
              caption: "Live multi-pair account with the robot running: 4 charts at once, every position with its Stop Loss and profits stacking up on their own. The balance climbs while you touch nothing.",
              alt: "Live MT5 account with the BreakOuts robot trading 4 charts at once",
            },
            links: [
              { label: "MYFXBOOK · LIVE ACCOUNT", text: "Full history of the Tickmill account traded by the robot.", href: "https://www.myfxbook.com/members/TheMarketKilla/themarketkilla-breakout-killa-premium/11918605" },
              { label: "MYFXBOOK PROFILE", text: "All of TheMarketKilla's verified accounts.", href: "https://www.myfxbook.com/members/TheMarketKilla" },
            ],
            disclaimer: "Every figure comes from accounts with public history: you can open the links and check it trade by trade, today. The robot trades with a Stop Loss on every entry and risk defined before opening: capital protection is the design principle.",
          },
          honest: {
            kicker: "NO HYPE, JUST PROOF",
            title: "What makes this robot different.",
            items: [
              "It passes prop firm challenges trading on its own. FTMO, FundedNext, E8: the robot enters, manages every trade and passes them without you touching a thing. You get the certificate.",
              "What you see here is one challenge approved today and another tomorrow. The list keeps growing, and each one keeps its public history so you can audit it.",
              "Risk defined on every entry. Stop Loss in place the moment it opens and risk capped before trading: capital protection comes before profitability. No Grid, no Martingale, no blown accounts.",
              "It trades several pairs at once. Up to 8 simultaneous positions across different charts, so it never depends on a single market or a single win.",
              "Your part takes two minutes. No coding and no chart-watching: drop the file into MT5, enable AutoTrading and the robot works for you from there.",
              "Live account, not demo. The Tickmill account traded by the robot is certified on Myfxbook and you can watch it live, trade by trade.",
              "One license, every chart you want. With the premium you cover all your accounts, on any broker, with a single payment.",
            ],
          },
          results: {
            kicker: "REAL RESULT · FTMO CHALLENGE",
            title: "Another challenge passed 100 % trading on its own.",
            text: "The robot passed the FTMO challenge on a $10,000 account, managing every entry with its Stop Loss and its capped risk. A 10.27 % gain with a 7.05 % drawdown: capital protection in front, profitability behind.",
            stats: [
              { label: "GAIN", value: "+10.27 %" },
              { label: "MAX DRAWDOWN", value: "7.05 %" },
              { label: "WIN RATE", value: "62 %" },
              { label: "PROFIT FACTOR", value: "1.69" },
              { label: "TRADES", value: "37" },
              { label: "CERTIFICATE", value: "PASSED" },
            ],
            image: {
              src: "/media/breakouts/myfxbook-ftmo-phase1.jpg",
              alt: "Result curve of the FTMO Challenge traded by the BreakOuts robot",
              label: "FTMO CHALLENGE 1 · PHASE 1",
              caption: "The challenge's growth curve on Myfxbook: equity rises steadily until it closes the target. FTMO demo account traded by the robot alone.",
            },
            note: "Figures are shown exactly as they appear on Myfxbook, with the public history available to audit whenever you want.",
          },
          faq: {
            kicker: "FAQ",
            title: "What people ask about the robot.",
            items: [
              { q: "How much does it cost?", a: "Two routes: free, if you open a Roboforex or Tickmill account (Pro·Classic) with my code; or premium, a one-time $200 with unlimited licenses on any broker, no referral needed." },
              { q: "Do I need to know how to code?", a: "No. Just drop the file into MT5 and enable it on a chart. I send you the 3 files and the step-by-step guide. Two minutes and it's trading." },
              { q: "How much capital do I need?", a: "As much as you want, as long as you respect the risk per trade. For prop firms, 0.5 %–1.5 % per trade is the recommendation: that way the robot enters every challenge with capital protection first." },
              { q: "Does it use Grid or Martingale?", a: "Never. That's one of the system's rules: no averaging a loser, no doubling lots. Every entry carries its Stop Loss and its risk defined before opening." },
              { q: "Which broker does it work with?", a: "Any MT5 with a premium license. For the free license it must be a Roboforex or Tickmill (Pro·Classic) account." },
              { q: "Can it pass prop-firm challenges?", a: "Yes, that's one of its main uses: FTMO and FundedNext are among the firms where the robot has already passed challenges trading on its own. The key is risk: 0.5 %–1.5 % per trade." },
              { q: "Can I use it on several accounts?", a: "Each account needs its own license. With the premium you can cover as many as you want, on any broker, with a single payment. Message me and I'll explain how it works for your case." },
            ],
          },
          final: {
            title: "Put the robot to work.",
            text: "Message me, I'll tell you which of the two licenses suits your case and send you the files with the installation guide. Today you can have it working on your account.",
            cta_label: "I want the robot",
            cta_href: "https://t.me/TheMarketKilla",
            cta2_label: "See the robot's Myfxbook",
            cta2_href: "https://www.myfxbook.com/members/TheMarketKilla/themarketkilla-breakout-killa-premium/11918605",
          },
          others_label: "OTHER SERVICES",
        },
        bullrun: {
          seo: {
            title: "Bull Run 2026 — Private crypto investment group (10 spots) | TheMarketKilla",
            description: "Private group of 10 people to ride the crypto bull cycle: what to accumulate, when to buy and when to sell. One-time $490.",
          },
          kicker: "BULL RUN 2026 · PRIVATE GROUP",
          title_a: "Ride the bull cycle",
          title_b: "with guidance, not blindly.",
          lead: "A private group I open once every four years, right before the bull run. We work hand in hand with only 10 people through the whole bull cycle: I tell you which coins to enter, when to buy and when to sell, with technical and fundamental analysis. You always keep control of your capital.",
          nav_label: "Bull Run 2026",
          cta_label: "Reserve my spot",
          cta_href: "https://t.me/TheMarketKilla",
          cta2_label: "Message me on Telegram",
          cta2_href: "https://t.me/TheMarketKilla",
          facts: [
            { label: "Spots", value: "Only 10" },
            { label: "Duration", value: "Whole cycle" },
            { label: "Projects", value: "+20" },
            { label: "Payment", value: "$490 once" },
          ],
          aside: {
            title: "The details",
            price: "$490",
            price_note: "one-time, whole cycle",
            items: [
              "Private group, only 10 people",
              "Strategy diversified across +20 projects",
              "Technical and fundamental analysis of each coin",
              "Step-by-step guidance: entry, buy and exit",
              "You trade from your own wallet",
              "Covers the whole cycle: 6 months to 1 year",
            ],
            note: "The goal is to multiply your capital (x20 or more) as in previous cycles. It's a goal, not a guarantee: nobody can promise that in crypto.",
          },
          how: {
            kicker: "HOW IT WORKS",
            title: "One strategy, twenty projects, ten people.",
            items: [
              { n: "01", t: "Selection of 20 projects", d: "Each coin makes the list after deep technical and fundamental analysis. No hype moonshots: projects with a thesis." },
              { n: "02", t: "Real diversification", d: "Instead of betting everything on one, capital is spread across at least 20 projects. That way one mistake doesn't take the whole portfolio." },
              { n: "03", t: "Guided entries and exits", d: "I tell you which coins to enter, when to buy, when to take profit and when to exit. No guessing." },
              { n: "04", t: "Your wallet, your control", d: "I never touch your money. You buy and sell from your own wallet with your own keys. I guide; you decide and execute." },
              { n: "05", t: "Support through the whole cycle", d: "It's not a course that ends. I stay with you for the entire cycle, until we sell the positions with the goal met." },
              { n: "06", t: "Only 10 people", d: "The limit exists so I can answer each one. When the spots fill, the group closes until the next cycle." },
            ],
          },
          steps: {
            kicker: "HOW TO JOIN",
            title: "Four steps to secure your spot.",
            items: [
              { n: "1", t: "Message me", d: "Tell me your situation and how much capital you plan to put into the cycle. No commitment." },
              { n: "2", t: "I confirm the spot", d: "I tell you whether spots are still open (there are only 10) and whether the group fits what you're after." },
              { n: "3", t: "One-time $490", d: "Paid once and covers the whole cycle, until the positions are sold. No monthly fees." },
              { n: "4", t: "You join the group", d: "I add you to the private group by invitation and we start working on the strategy." },
            ],
            footnote: "If the group is already full, I'll tell you and put you on the list for the next cycle. I don't sell spots that don't exist.",
          },
          proof: {
            kicker: "WHY 10 SPOTS",
            title: "The exclusivity is about attention, not marketing.",
            text: "With 10 people I can read each person's situation, answer their questions and adjust the guidance to their capital. With 300, this would be just another signals channel. The proof the work is done well is the one-on-one treatment through the whole cycle.",
            shots: [],
            video: null,
            links: [],
            disclaimer: null,
          },
          honest: {
            kicker: "NO HYPE",
            title: "What this group is NOT.",
            items: [
              "It's not money management: nobody touches your capital. You trade, from your own wallet.",
              "It's not a guaranteed x20. It's the goal I work towards, based on previous cycles.",
              "It's not a recorded course or a short-term buy/sell signals channel.",
              "It's not for everyone: if you can't ride the volatility of a full crypto cycle, it's not your place.",
            ],
          },
          faq: {
            kicker: "FAQ",
            title: "What people ask before joining.",
            items: [
              { q: "How much does it cost?", a: "A one-time $490. It covers the whole bull cycle, until we sell the positions with the goal met. No monthly fees." },
              { q: "When does the group open?", a: "Once every four years, before the bull run. It's open right now: those interested are still in time." },
              { q: "How many people get in?", a: "Only 10. The limit is so I can answer each one personally throughout the cycle." },
              { q: "Do you manage my money?", a: "No, never. You have full control: everything happens from your own wallet, with your own keys. I only guide." },
              { q: "How much can I make?", a: "The goal is to multiply your capital x20 or more, as in previous cycles. It's a goal, not a guarantee." },
              { q: "How long does it last?", a: "The whole bull cycle, roughly 6 months to a year, depending on how the market develops." },
              { q: "Do I need to know crypto?", a: "It's not essential, but you do need to know how to buy and sell on a platform. I guide you through the rest, including which platforms to use." },
            ],
          },
          final: {
            title: "Spots are open for this cycle.",
            text: "The group opens once every four years and it's ten people. If you're interested, message me now and I'll confirm whether there's still room.",
            cta_label: "Reserve my spot",
            cta_href: "https://t.me/TheMarketKilla",
            cta2_label: "Message me on Telegram",
            cta2_href: "https://t.me/TheMarketKilla",
          },
          others_label: "OTHER SERVICES",
        },
        senales: {
          seo: {
            title: "Trading signals — Forex, Crypto, Indices and Metals | TheMarketKilla",
            description: "2 to 10 signals a week with a strict Stop Loss, Take Profit, BreakEven and TrailingStop. Forex, Crypto, Indices and Metals. From $30/month.",
          },
          kicker: "SIGNALS · FOREX · CRYPTO · INDICES",
          title_a: "Every signal with its Stop Loss",
          title_b: "and its exit plan.",
          lead: "Trading signals for Forex, Crypto, Indices and Metals, built for personal accounts and prop-firm accounts alike. Not a bare entry dropped in a chat: every signal comes with entry, strict Stop Loss, Take Profit, BreakEven and TrailingStop, so you know exactly how to manage it.",
          nav_label: "Signals",
          cta_label: "Add me to the list",
          cta_href: "https://t.me/TheMarketKilla",
          cta2_label: "Message me on Telegram",
          cta2_href: "https://t.me/TheMarketKilla",
          facts: [
            { label: "Markets", value: "4 classes" },
            { label: "Frequency", value: "2–10/week" },
            { label: "Management", value: "SL + TP" },
            { label: "From", value: "$30/mo" },
          ],
          aside: {
            title: "Plans",
            price: "$30",
            price_note: "per month · longer plans available",
            items: [
              "Monthly: $30/month",
              "Quarterly: $75 (~$25/mo, save ~17 %)",
              "Half-year: $135 (~$22.50/mo, save 25 %)",
              "Yearly: $240 (~$20/mo, save ~33 %)",
              "Lifetime: $490 one-time",
              "Every signal includes SL + TP + BreakEven + TrailingStop",
            ],
            note: "Service in preparation: plans and prices are already set. Coming very soon. The list closes in order of arrival.",
          },
          how: {
            kicker: "HOW IT WORKS",
            title: "2 to 10 signals a week, with risk management.",
            items: [
              { n: "01", t: "Weekly selection", d: "2 to 10 signals a week across Forex, Crypto, Indices and Metals. Few and chosen: no spamming you with 40 entries." },
              { n: "02", t: "Entry and clear Stop Loss", d: "Every signal carries the entry point and a strict Stop Loss, set before opening. You know your risk from the start." },
              { n: "03", t: "Take Profit and BreakEven", d: "Along with the TP, the signal tells you when to move to BreakEven to remove risk once the market moves in your favour." },
              { n: "04", t: "TrailingStop", d: "Guidance to let the trade run with a TrailingStop, capturing more range without giving back profit already made." },
              { n: "05", t: "Prop-firm friendly", d: "The risk management is built for personal accounts and prop-firm accounts, where excess risk disqualifies you." },
              { n: "06", t: "Delivered in a private channel", d: "Signals are delivered through a private Telegram channel, at entry time, with every parameter." },
            ],
          },
          steps: {
            kicker: "HOW TO START",
            title: "It's being prepared. Here's how you'll join.",
            items: [
              { n: "1", t: "Join the list", d: "The service is currently in preparation. Message me and I'll put you on the list to notify you the moment it opens." },
              { n: "2", t: "Pick a plan", d: "When it opens, pick your plan: $30/mo, $75 quarterly, $135 half-year, $240 yearly or $490 lifetime." },
              { n: "3", t: "Join the channel", d: "You get access to the private signals-delivery channel." },
              { n: "4", t: "Trade each signal", d: "You receive the entry, Stop Loss, Take Profit and the BreakEven and TrailingStop guidance. You execute and manage." },
            ],
            footnote: "If you join the list now, you get priority when we open: the list closes in order of arrival.",
          },
          proof: {
            kicker: "SERVICE STATUS",
            title: "It isn't launched yet.",
            text: "We'd rather say it plainly: the signals service is in preparation and hasn't launched. What defines the service is already locked in, but I'd rather let you know and have you join when it's genuinely working than sell you access early. If you message me, I'll put you on the list and tell you the day it opens.",
            shots: [],
            video: null,
            links: [],
            disclaimer: null,
          },
          honest: {
            kicker: "NO HYPE",
            title: "What this service is NOT.",
            items: [
              "It's not a group of 'unfailing signals': no signal guarantees a win. That's why each one carries its Stop Loss.",
              "It's not a robot: you trade the signals manually, following the parameters.",
              "I don't promise a number of winning trades per month. The commitment is the process: strict SL and disciplined management.",
              "It isn't open yet: I'll tell you when it is, instead of charging you upfront.",
            ],
          },
          faq: {
            kicker: "FAQ",
            title: "What people ask about the signals.",
            items: [
              { q: "Is it available yet?", a: "Not yet: the service is coming very soon. You can join the list and I'll tell you the moment it opens." },
              { q: "Which markets does it cover?", a: "Forex, Crypto, Indices and Metals. Four asset classes, focused on the week's best opportunities." },
              { q: "How many signals arrive per week?", a: "Between 2 and 10. The idea is quality over quantity: a few well-chosen entries instead of constant noise." },
              { q: "What does each signal include?", a: "Entry, a strict and clear Stop Loss, Take Profit and BreakEven and TrailingStop guidance. All with concrete parameters." },
              { q: "Does it work for prop-firm accounts?", a: "Yes, it's also built for prop firms. The risk management follows the limits that type of account requires." },
              { q: "How much does it cost?", a: "From $30/month. There's also quarterly ($75), half-year ($135), yearly ($240) and lifetime ($490)." },
              { q: "Where do the signals arrive?", a: "Through a private Telegram channel, with all entry and management parameters. I give you access when you activate your plan." },
            ],
          },
          final: {
            title: "Get on the list before it opens.",
            text: "The service is in preparation and the list closes in order of arrival. Message me and I'll tell you the day it starts running.",
            cta_label: "Add me to the list",
            cta_href: "https://t.me/TheMarketKilla",
            cta2_label: "Message me on Telegram",
            cta2_href: "https://t.me/TheMarketKilla",
          },
          others_label: "OTHER SERVICES",
        },
      },
    },
    pricing: {
      kicker: "ACCESS",
      title: "Each service, its price.",
      subtitle:
        "No locked-in subscriptions and no plans I don't use. What it costs is what you see.",
      mo: "/mo",
      once: "one-time",
      most: "MOST CHOSEN",
      cta: "Message me on Telegram",
      tier_cta: "See the service",
      hire_cta: "Hire now",
      tiers: [
        {
          name: "COPYTRADING",
          price: "FREE",
          tagline: "Only with my referral code",
          features: [
            "Automatic copy of my trades",
            "Gold (XAUUSD) scalping",
            "Transparent Master account",
            "$100 minimum in your account",
            "No fees, no monthly payments",
          ],
          note: "Free for all Roboforex referrals. No fees, no monthly payments.",
        },
        {
          name: "BREAKOUTS ROBOT",
          price: "$200",
          price_was: "$490",
          discount: "SAVE $290 · -59%",
          tagline: "Premium license · any broker",
          features: [
            "The robot on your MT5, multi-pair",
            "Stop under structure + BreakEven + Trailing",
            "No Grid, no Martingale",
            "Works for prop firms (FTMO/FundedNext)",
            "One-time payment, yours for good",
          ],
          note: "Limited-time offer. With a Roboforex or Tickmill account (Pro·Classic) and my code, the license comes out free.",
        },
        {
          name: "BULL RUN 2026",
          price: "$490",
          tagline: "Private group · only 10 spots",
          features: [
            "Guided route through the bull cycle",
            "What to accumulate and why, with macro vision",
            "Tactical rebalancing along the way",
            "Direct access to me, one on one",
            "One-time payment, no subscriptions",
          ],
          note: "Only 10 people: when it fills, it closes.",
        },
        {
          name: "SIGNALS",
          price: "From $30",
          tagline: "Forex · Crypto · Indices · Metals",
          features: [
            "2-10 signals per week",
            "Strict Stop Loss on every entry",
            "Take Profit, BreakEven and TrailingStop",
            "Delivered directly on Telegram",
            "$30/mo · $75/3m · $135/6m · $240/12m",
          ],
          note: "🕒 Coming very soon. The list closes in order of arrival.",
        },
      ],
    },
    contact: {
      kicker: "CONTACT",
      title: "Talk to me directly.",
      subtitle:
        "No forms, no middlemen. You message me on Telegram, tell me what you're after, and I'll tell you if I can help.",
      telegram: "Message me privately",
      channel: "Join the channel",
      panel_title: "One message and we talk.",
      panel_text:
        "Tell me what you're after — copying my trades, the robot, the Bull Run group or the signals — and I'll tell you straight if it fits you. No forms, no waiting, no salespeople in between.",
      email_label: "Email",
      cards: {
        dm: { label: "TELEGRAM", value: "@TheMarketKilla" },
        channel: { label: "CHANNEL", value: "The_Market_Killa" },
        email: { label: "EMAIL", value: "themarketkilla@hotmail.com" },
      },
      note: "You get me, not a bot. If I don't answer right away, I'm in front of the chart.",
    },
    footer: {
      tagline: "+10 years trading. +500 strategies programmed.",
      legal: "TheMarketKilla is not a registered company. The Master account data is published openly.",
      copy: "All rights reserved.",
      channels: "CHANNELS",
      contact: "CONTACT",
      nav: "NAV",
      terms: "Terms",
      privacy: "Privacy",
      copyCanal: "Join the CopyTrading channel",
      roboforex: "Open a Roboforex account",
    },
  },
};

export default translations;
